import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CustomQuarterPickerComponent} from './custom-quarter-picker.component';

@NgModule({
    imports: [CommonModule],
    declarations: [CustomQuarterPickerComponent],
    exports: [CustomQuarterPickerComponent],
})
export class CustomQuarterPickerModule {}



// WEBPACK FOOTER //
// ./src/app/shared/ngbmomentpickers/custom-quarter-picker/custom-quarter-picker.module.ts